<template>
    <v-menu ref="cart-menu" v-model="menu" :close-on-content-click="false" max-width="400" nudge-width="200" offset-y>
        <template v-slot:activator="{ on }">
            <v-btn v-if="!isMobile" v-on="on"
                :disabled="$wait.is('loading webshop getProducts') || $wait.is('loading webshop GetCampaignProducts')"
                :loading="cartLoading" class="align-self-center" color="primary" height="100%" style="order: 2;" text small
                @click="onMenuButtonClick">
                <v-icon size="28px" v-show="!headerProps.atTop && headerProps.layout === 'portal'"
                    color="var(--v-secondary-base)" style="cursor: pointer">fxt-cart</v-icon>
                <v-icon size="28px" v-show="headerProps.atTop && headerProps.layout === 'portal'" color="primary"
                    style="cursor: pointer">fxt-cart</v-icon>
                <v-icon size="28px" v-show="!headerProps.atTop && headerProps.layout !== 'portal'" color="primary"
                    style="cursor: pointer">fxt-cart</v-icon>

                <v-badge overlap v-if="cartProductsCount" color="red" right
                    style="margin:0px 5px 35px 0px; padding-left: 0px;">
                    <template v-if="initDataFetched" v-slot:badge>
                        {{ cartProductsCount }}
                    </template>
                </v-badge>
            </v-btn>
            <v-btn v-else v-on="on"
                :disabled="$wait.is('loading webshop getProducts') || $wait.is('loading webshop GetCampaignProducts')"
                :loading="cartLoading" @click.stop="onMenuButtonClick" min-width="60" small :class="$route.name == 'webshopChainShoppingCartClickAndCollect' ? 'mobile-navigation__btn-active' : ''">
                <span>Handlekurv</span>
                <v-icon>fxt-cart</v-icon>
                <v-badge v-if="cartProductsCount" color="red" overlap right style="margin:0px -5px 0px 25px;">
                    <template v-if="initDataFetched" v-slot:badge>
                        {{ cartProductsCount }}
                    </template>
                </v-badge>
            </v-btn>
        </template>

        <!-- <div v-if="initDataFetched && carts.length > 1">
            <v-list class="pa-0">
                <template v-for="salonCart in carts">
                    <v-list-item :key="salonCart.siteId" style="cursor: pointer;" @click="goToCheckout(salonCart)">
                        <div style="position: relative; padding: 15px 15px 15px 0">
                            <v-icon large>fxt-cart</v-icon>
                            <div style="position: absolute; top: 5px; right: 25px">
                                <v-badge :content="cartSalonCount(salonCart.siteId)" color="red"></v-badge>
                            </div>
                        </div>

                        <v-list-item-content>
                            <v-list-item-title>{{ cartSalon(salonCart.siteId).siteName }}</v-list-item-title>
                            <v-list-item-subtitle class="text-uppercase text-wrap">
                                {{ cartSalon(salonCart.siteId).address }}, {{ cartSalon(salonCart.siteId).postalArea }} {{
                                    cartSalon(salonCart.siteId).postalCode }}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action v-ripple>
                            <v-icon color="primary">fxt-chevron-right</v-icon>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider :key="salonCart.siteId + '-divider'" />
                </template>
            </v-list>

            <div v-if="!carts.length" class="px-4 py-4 white">
                <v-icon>fxt-cart</v-icon>
                Du har ingen produkter i handlevognen
            </div>
        </div> -->
    </v-menu>
</template>

<script>
import webshopMixins from './webshop.mixins'

import { Header } from '@fixit/fixit-no-header/src/models';
import { FixitIcon } from '@fixit/icons'

export default {
    mixins: [webshopMixins],
    props: {
        initDataFetched: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        isMobile: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        /**
         * Options for integrated FixitNoHeader component
         *
         * required :
         *  @param {apiUrl} apiUrl url endpoint for login
         *
         * optional :
         *  @param {headerColors} headerColors  default ["#BFE5E8", "#EFDDD1"] ;
         *  @param {height} height  default 70 ;
         *  @param {elevation} elevation  default 3 ;
         *  @param {items} items  default [] ;
         *  @param {layout} layout  default 'chain' ;
         *  @param {atTop} atTop  default false ;
         * @see TheFixitNoHeader
         */
        headerProps: {
            type: Header,
            default: function () {
                return new Header();
            },
        },
    },// ['initDataFetched', 'isMobile'],
    components: {
        FixitIcon
    },
    data() {
        return {
            menu: false
        }
    },
    methods: {
        onMenuButtonClick() {
            this.goToCheckout()
        },
        goToCheckout() {
            this.$refs['cart-menu'].isActive = false;
            this.$router.push({
                name: 'webshopChainShoppingCartClickAndCollect',
                params: {
                    chainId: this.$route.params.chainId || this.$route.query.chainId,
                }
            }).catch(e => {
            })
        },

        availableInSelectedSalon(item) {
            return true
        },

        outOfStock(item) {
            return item.productDetails.inventory <= 0 || (item.quantity === item.productDetails.inventory)
        },

        clearCartPromptDialogAction() {
            this.$store.dispatch('clickAndCollect/set', { key: 'clearCartPromptDialog', value: true })
        },
        cartSalonCount(siteId) {
            return this.$store.getters['checkout/cartCount'](siteId);
        },
        cartSalon(siteId) {
            var salon = this.salons.find(s => s.siteId == siteId)
            return salon
        }
    },
    computed: {
        cartLoading() {
            return this.$wait.is('loading clickAndCollect fetchCartFromDb') || this.$wait.is('loading user userLoggedInActions') || this.$wait.is('loading clickAndCollect clearCart') || !this.initDataFetched;
        },
        cartProductsCount() {
            return this.$store.getters['checkout/cartsCount']
        },
    },
    created() {
        this.$eventBus.$on('webshop-activate-cart', () => this.$refs['cart-menu'].isActive = true);
    }
}
</script>

<style></style>
